var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsvoznoauthorized2 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.16667C13.3333 3.77614 10.5572 1 7.16667 1C3.77614 1 1 3.77614 1 7.16667C1 10.5572 3.77614 13.3333 7.16667 13.3333C10.5572 13.3333 13.3333 10.5572 13.3333 7.16667ZM14.3333 7.16667C14.3333 11.1095 11.1095 14.3333 7.16667 14.3333C3.22386 14.3333 0 11.1095 0 7.16667C0 3.22386 3.22386 0 7.16667 0C11.1095 0 14.3333 3.22386 14.3333 7.16667Z",
    fill: "#AA0233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.83333V4.5C6.66667 4.22386 6.89052 4 7.16667 4C7.44281 4 7.66667 4.22386 7.66667 4.5V7.83333C7.66667 8.10948 7.44281 8.33333 7.16667 8.33333C6.89052 8.33333 6.66667 8.10948 6.66667 7.83333Z",
    fill: "#AA0233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16886 9.16667C7.53705 9.16667 7.83553 9.46514 7.83553 9.83333C7.83553 10.2015 7.53705 10.5 7.16886 10.5H7.163C6.79482 10.5 6.49634 10.2015 6.49634 9.83333C6.49634 9.46514 6.79482 9.16667 7.163 9.16667H7.16886Z",
    fill: "#AA0233"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsvoznoauthorized2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsvoznoauthorized2.fb4410d5.svg";
export { ForwardRef as ReactComponent };